import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Fab,
  Snackbar,
  Alert,
  Drawer,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { Routes, Route, useNavigate } from "react-router-dom";
import SyncIcon from "@mui/icons-material/Sync";
import { keyframes } from "@emotion/react";
import db from "../db";
// import { handleSync } from "../utils/global_functions";
import { handleSync, pingServer, syncPendingRecords } from "../utils/global_functions";
import DrawerContent from "../components/DrawerContent";
import HeaderAppBar from "../components/HeaderAppBar";
import FingerprintScanner from "../components/FingerprintScanner";
import AttendanceHistory from "../components/AttendanceHistory";
import MyAttPage from "../pages/MyAttPage";
import AllAttendancePage from "../pages/AllAttendancePage";
import AllAttendanceNewPage from "../pages/AllAttendanceNewPage";
import ApproveLeavePage from "./ApproveLeavePage";
import LeaveRolesPage from "./LeaveRolesPage";
import VisitRolesPage from "./VisitRolesPage";
import SettingsDropdown from "../components/SettingsDropdown";
import VisitHistoryPage from "../pages/VisitHistoryPage";
import NotificationRolesPage from "../pages/NotificationRolesPage"
import ApproveVisitPage from "../pages/ApproveVisitPage";
import VisitReportPage from "../components/VisitReportPage";
import LeaveRequestHistory from "../components/LeaveRequestHistory";
import AllEmployeesActions from "../components/AllEmployeesActions";
import FingerprintManually from "../components/FingerprintManually";

//*Url protected !!
import ProtectedRoute from "../components/ProtectedRoute";

export default function HomePage() {
  const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;

  const navigate = useNavigate();
  const fullName = localStorage.getItem("shared_fullname") || "User";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncStatus, setSyncStatus] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const attendanceRef = useRef(null);

  const openDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);

  const handleSyncClick = async () => {
    setSyncing(true);

    const entries = await db.attendance
      .where("recordstatusid")
      .equals(1)
      .toArray();

    const transformed = entries.map((entry) => ({
      mobileNumber: entry.mobileNumber,
      full_name: entry.full_name,
      device_name: entry.device_name,
      latitude: entry.latitude,
      longitude: entry.longitude,
      address: entry.address,
      street: "",
      building: "",
      nearby: entry.address,
      confirm_date: entry.confirm_date,
      confirm_time: entry.confirm_time,
      ip: entry.ip,
    }));

    const result = await handleSync(transformed, 0);

    if (result.success) {
      await db.attendance.clear();
      attendanceRef.current?.clearHistory();
    }

    setSyncStatus({
      open: true,
      message: result.message,
      severity: result.success ? "success" : "error",
    });

    setSyncing(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("remember_me");
    navigate("/");
  };
  
   useEffect(() => {
    const API_BASE_URL = localStorage.getItem("saved_sett_api_url") || "http://localhost:5100";

    const checkAndSync = async () => {
      const reachable = await pingServer(API_BASE_URL);
      if (reachable) await syncPendingRecords();
    };

    checkAndSync(); // run once when the app/session starts
    const interval = setInterval(checkAndSync, 15000); // poll every 15s

    window.addEventListener("online", checkAndSync);

    const onVisible = () => {
      if (document.visibilityState === "visible") checkAndSync();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(interval);
      window.removeEventListener("online", checkAndSync);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return (
    <>
      <HeaderAppBar
        fullName={fullName}
        handleLogout={handleLogout}
        toggleDrawer={openDrawer}
      />

     

      {isMobile ? (
        <SwipeableDrawer
          anchor="right"
          open={drawerOpen}
          onOpen={openDrawer}
          onClose={closeDrawer}
          disableDiscovery={false}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: 280 } }}
        >
          <DrawerContent onLogout={handleLogout} onClose={closeDrawer} />
        </SwipeableDrawer>
      ) : (
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={closeDrawer}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: 280 } }}
        >
          <DrawerContent onLogout={handleLogout} onClose={closeDrawer} />
        </Drawer>
      )}

      <Container sx={{ py: 4}}>
        <Routes>
        {/* ── Public: any logged-in user ── */}
          <Route path="/" element={<FingerprintScanner />} />
          <Route
            path="history"
            element={<AttendanceHistory ref={attendanceRef} />}
          />
          <Route path="calendar" element={<MyAttPage />} />
          <Route path="calendar/visits"  element={<VisitHistoryPage />} />
          <Route path="settings/leaveroles" element= {<LeaveRolesPage /> }/>
          <Route path="settings/visitroles" element={<VisitRolesPage />} />
          <Route path="settings/notificationroles" element={<NotificationRolesPage />} />

          
          <Route path="calendar/approve-visits" element={<ApproveVisitPage />} />

          <Route path="calendar/all" element={<AllAttendancePage />} />
          <Route path="calendar/new" element={<AllAttendanceNewPage />} />

          <Route path="calendar/approve" element={ <ApproveLeavePage /> } />
          <Route path="calendar/visit-report" element={<VisitReportPage />} />
          <Route path="calendar/leaveRequest" element={<LeaveRequestHistory />} />
          <Route path="calendar/EmployeesActions" element={<AllEmployeesActions />} />
          <Route path="calendar/ManualAttendance" element={<FingerprintManually />} />
          

        {/* ── Admin only: redirects to /home if UID not in allowedUsers ── */}
          {/* <Route path="calendar/all" element={
            <ProtectedRoute><AllAttendancePage /> </ProtectedRoute>} />
          <Route path="calendar/new" element={
           <ProtectedRoute> <AllAttendanceNewPage /> </ProtectedRoute>} />
          <Route path="calendar/approve" element={
           <ProtectedRoute> <ApproveLeavePage /> </ProtectedRoute>} /> */}
          {/* <Route path="settings/leaveroles" element={
            <ProtectedRoute><LeaveRolesPage /> </ProtectedRoute>} />
            <Route path="settings/visitroles" element={
            <ProtectedRoute><VisitRolesPage /> </ProtectedRoute>} /> */}

            {/* <Route path="calendar/approve-visits" element={<ApproveVisitPage />} />  */}
            
        </Routes>
      </Container>

      { /*<Fab
        color="primary"
        size="medium"
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
          zIndex: 1300,
        }}
        onClick={handleSyncClick}
      >
        <SyncIcon
          sx={{
            animation: syncing ? `${spin} 1s linear infinite` : "none",
          }}
        />
      </Fab>*/ }

      <Snackbar
        open={syncStatus.open}
        autoHideDuration={4000}
        onClose={() => setSyncStatus((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={syncStatus.severity}
          onClose={() => setSyncStatus((prev) => ({ ...prev, open: false }))}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {syncStatus.message}
        </Alert>
      </Snackbar>
    </>
  );
}
